import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.824 2.3H3.491a2 2 0 0 0-2 2v6.667a2 2 0 0 0 2 2h1.76l-.387.666a1.333 1.333 0 0 0 1.167 2h4.307a1.334 1.334 0 0 0 1.153-2l-.393-.666h1.726a2 2 0 0 0 2-2V4.3a2 2 0 0 0-2-2m-6.82 12 .82-1.333h2.667l.8 1.333zm7.487-3.333a.667.667 0 0 1-.667.666H3.491a.667.667 0 0 1-.667-.666V10.3h10.667zm0-2H2.824V4.3a.667.667 0 0 1 .667-.667h9.333a.667.667 0 0 1 .667.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })